import React, { useEffect, useMemo, useState } from "react";
import { Button, Pagination } from "semantic-ui-react";
import MeHealthPaymentHistoryFilter from "./MeHealthPaymentHistoryFilter";
import MeHealthPaymentHistoryTable from "./MeHealthPaymentHistoryTable";
import { convertThaiDateToISO } from "react-lib/utils/dateUtils";
import moment from "moment";

const ROWS_PER_PAGE = 5;

type PaymentHistoryTabProps = {
  BillingAndPackageSequence: any;
  runSequence: any;
  setProp: any;
  primaryColor: string;
  borderColor: string;
  downloadIconSrc: string;
  onClose: () => void;
  closeButtonColor: string;
};

const MeHealthPaymentHistoryTab = (props: PaymentHistoryTabProps) => {
  const [searchDateFrom, setSearchDateFrom] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");
  const [filterOrderNo, setFilterOrderNo] = useState("");
  const [selectedPackage, setSelectedPackage] = useState("ALL");
  const [activeHistoryPage, setActiveHistoryPage] = useState(1);
  // const [isSearching, setIsSearching] = useState(false);
  // const [filteredPaymentHistory, setFilteredPaymentHistory] = useState<any[]>([]);

  // useEffect(() => {
  //   setFilteredPaymentHistory(props.BillingAndPackageSequence.paymentHistory?.items || []);
  // }, [props.BillingAndPackageSequence.paymentHistory]);

  const dateFromISO = convertThaiDateToISO(searchDateFrom);
  const dateToISO = convertThaiDateToISO(searchDateTo);

  useEffect(() => {
    handleSearch()
    return () => {
      props.setProp("BillingAndPackageSequence", {
        ...props.BillingAndPackageSequence,
        paymentHistory: null
      })
    }
  }, [])

  useEffect(() => {
    if (!searchDateFrom || !searchDateTo) {
      const startOfMonth = moment().startOf("month");
      const endOfMonth = moment().endOf("month");

      const formatBuddhist = (date: moment.Moment) =>
        `${date.date().toString().padStart(2, "0")}/` +
        `${(date.month() + 1).toString().padStart(2, "0")}/` +
        `${date.year() + 543}`;

      if (!searchDateFrom) setSearchDateFrom(formatBuddhist(startOfMonth));
      if (!searchDateTo) setSearchDateTo(formatBuddhist(endOfMonth));
    }
  }, []);

  const packageOptions = useMemo(() => {
    if (Array.isArray(props.BillingAndPackageSequence.paymentHistory?.items)) {
      return [
        { key: "ALL", value: "ALL", text: "All" },
        ...Array.from(
          new Set(
            (props.BillingAndPackageSequence?.paymentHistory?.items || []).flatMap((item) =>
              item.order_detail.split(",").map((name: string) => name.trim())
            )
          )
        ).map((name) => ({
          key: name,
          value: name,
          text: name,
        })),
      ];
    } else {
      return [{ key: "ALL", value: "ALL", text: "All" }]
    }

  }, [props.BillingAndPackageSequence.paymentHistory]);

  const displayedRows = (props.BillingAndPackageSequence?.paymentHistory?.items || []).slice(
    (activeHistoryPage - 1) * ROWS_PER_PAGE,
    activeHistoryPage * ROWS_PER_PAGE
  );
  const emptyRows = Array.from({
    length: Math.max(ROWS_PER_PAGE - displayedRows.length, 0),
  });
  const totalHistoryPages = Math.ceil((props.BillingAndPackageSequence?.paymentHistory?.items || []).length / ROWS_PER_PAGE) || 1;



  const handleSearch = async () => {
    // setIsSearching(true);

    setActiveHistoryPage(1);

    props.runSequence({
      sequence: "BillingAndPackage",
      action: "GET_RECEIPT_LIST",
      order_no: filterOrderNo,
      package: selectedPackage !== "ALL" ? selectedPackage : "",
      payout_date_start: dateFromISO,
      payout_date_end: dateToISO,
    });

    // setFilteredPaymentHistory(data?.items || []);

    // setIsSearching(false);
  };

  const handleDownloadReceipt = (row: any) =>
    props.runSequence({
      sequence: "BillingAndPackage",
      action: "DOWNLOAD_RECEIPT",
      receipt: row,
    });

  return (
    <>
      <MeHealthPaymentHistoryFilter
        filterOrderNo={filterOrderNo}
        onFilterOrderNoChange={setFilterOrderNo}
        selectedPackage={selectedPackage}
        onPackageChange={(value) => setSelectedPackage(String(value))}
        packageOptions={packageOptions}
        searchDateFrom={searchDateFrom}
        onSearchDateFromChange={setSearchDateFrom}
        searchDateTo={searchDateTo}
        onSearchDateToChange={setSearchDateTo}
        isSearching={props.BillingAndPackageSequence?.paymentHistoryLoading}
        onSearch={handleSearch}
        primaryColor={props.primaryColor}
      />

      <MeHealthPaymentHistoryTable
        displayedRows={displayedRows}
        emptyRows={emptyRows}
        onDownloadReceipt={handleDownloadReceipt}
        downloadIconSrc={props.downloadIconSrc}
        borderColor={props.borderColor}
      />

      <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
        <Pagination
          activePage={activeHistoryPage}
          totalPages={totalHistoryPages}
          onPageChange={(e, { activePage }) => setActiveHistoryPage(Number(activePage))}
          ellipsisItem={{ content: "…", icon: true }}
          boundaryRange={2}
          siblingRange={1}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
        <Button onClick={props.onClose} style={{ color: "white", backgroundColor: props.closeButtonColor }}>
          ปิดหน้าจอ
        </Button>
      </div>
    </>
  );
};

export default MeHealthPaymentHistoryTab;
